import { useCookies } from 'vue3-cookies'
import { jwtVerify, importJWK, decodeJwt } from 'jose'
import logger from '../logger.ts'
import type { IAOEConfig } from '../types/AoeTypes.ts'
import { redactSecret } from '../utils/redactSecret'

declare const AOEConfig: IAOEConfig

let imageRootUrl: string = ''
let reviewRootUrl: string = ''
let apiKey: string = ''
let productRootUrl: string = ''
let orderEntryConnectorUrl: string = ''
let webConnectorUrl: string = ''
let bearerToken: string = ''
let beeNumberAuthenicatedUser: number | null = null
let authenticatedUserClassId: string | null = null
let beeNumberSite: number | null = null
let homeOfficeBeeNumber: number = 1
let orderTypeId: string = ''
let kitOrderTypeId: string = ''
let sessionInformationLoaded = false
let wishlistDetailUrl: string = ''
let wishlistUrl: string = ''
let rootUrl: string = ''
let cartDetailUrl: string = ''
let kitCartUrl: string = ''
let hostBenefitsUrl: string = ''
let logoutUrl: string = ''
let loginUrl: string = ''
let checkoutUrl: string = ''
let kitCheckoutUrl: string = ''
let kitRecruiterSelectionUrl: string = ''
let thankyouUrl: string = ''
let productReviewUrl: string = ''
let partyOrderEntryUrl: string = ''
let contactOrderEntryUrl: string = ''
let invoicePaymentUrl: string = ''
let eventManagementUrl: string = ''
let addressBookEditUrl: string = ''
let consultantLocatorUrl: string = ''
let eventListUrl: string = ''
let cultureName: string = ''
let webConnectorToken: string = ''
let countryCode: string = ''
let hostDashboardUrl: string = ''
let orderReceiptUrl: string = ''
let currentContentId: number=0
let passwordRegex: string = ''
let webConnectorExtensionsUrl: string = ''
let leadListUrl: string = ''
let shopUrl: string = ''
let hostPortalUrl: string = ''
let rmaEntryUrl: string = ''
let replicatedSiteBusinessName: string = ''
let googleMapsAPIKey: string = ''
let siteHomeofficeUrl: string = ''
let reportUrl: string = ''
let termsUrl: string = ''
let privacyPolicyUrl: string = ''
let consultantAgreementUrl: string = ''
let prohibitedPracticesUrl: string = ''
let codeOfConductUrl: string = ''
let backOfficeUrl: string = ''
let newUserWizardUrl: string = ''
let termsAndConditionsPageUrl: string = ''
let becomeConsultantUrl: string = ''
let orderEntryUrl: string = ''
let kitEnhancementUrl: string = ''
let recipeUrl: string = ''
let myStoryUrl: string = ''
let debugLoggingId: string = ''
let defaultConsultantPhotoUrl: string = ''

async function LoadSetting() {
  if (sessionInformationLoaded === true) return
  const { cookies } = useCookies()
  if (import.meta.env.VITE_SETTINGS_LOCATION === 'ENV') {
    logger.debug('LoadSetting from ENV')
    apiKey = import.meta.env.VITE_API_KEY
    productRootUrl = trimTrailingSlash(import.meta.env.VITE_PRODUCT_ROOT_URL, 'productRootUrl')
    imageRootUrl = trimTrailingSlash(import.meta.env.VITE_IMAGE_ROOT_URL, 'imageRootUrl')
    reviewRootUrl = trimTrailingSlash(import.meta.env.VITE_REVIEW_ROOT_URL, 'reviewRootUrl')
    orderEntryConnectorUrl = trimTrailingSlash(
      import.meta.env.VITE_ORDER_ENTRY_CONNECTOR_URL, 'orderEntryConnectorUrl'
    )
    webConnectorExtensionsUrl = trimTrailingSlash(
      import.meta.env.VITE_WEB_CONNECTOR_EXTENSIONS_URL, 'webConnectorExtensionsUrl'
    )
    webConnectorUrl = trimTrailingSlash(
      import.meta.env.VITE_WEB_CONNECTOR_URL, 'webConnectorUrl'
    )
    bearerToken = import.meta.env.VITE_BEARER_TOKEN
    orderTypeId = import.meta.env.VITE_ORDER_TYPE_ID
    cultureName = import.meta.env.VITE_CULTURE_NAME
    webConnectorToken = import.meta.env.VITE_WEB_CONNECTOR_TOKEN
    defaultConsultantPhotoUrl = import.meta.env.VITE_DEFAULT_CONSULTANT_PHOTO_URL ||
      'https://ttgcommon-180003f.s3.eu-central-1.amazonaws.com/tpc/default-consultant-photo.png'
  } else {
    logger.debug('LoadSetting from HTML,Cookies')
    if (AOEConfig) {
      orderTypeId = AOEConfig.OrderTypeId
      kitOrderTypeId = AOEConfig.KitOrderTypeId
      productRootUrl = trimTrailingSlash(AOEConfig.ProductRootUrl, 'productRootUrl')
      imageRootUrl = trimTrailingSlash(AOEConfig.ImageRootUrl, 'imageRootUrl')
      reviewRootUrl = trimTrailingSlash(AOEConfig.ReviewRootUrl, 'reviewRootUrl')
      orderEntryConnectorUrl = trimTrailingSlash(
        AOEConfig.OrderEntryConnectorApi, 'orderEntryConnectorUrl'
      )
      webConnectorUrl = trimTrailingSlash(
        AOEConfig.WebConnectorApi, 'webConnectorUrl'
      )
      wishlistDetailUrl = trimTrailingSlash(AOEConfig.WishlistDetailUrl, 'wishlistDetailUrl')
      wishlistUrl = trimTrailingSlash(AOEConfig.WishlistUrl, 'wishlistUrl')
      rootUrl = trimTrailingSlash(AOEConfig.RootUrl, 'rootUrl')
      cartDetailUrl = trimTrailingSlash(AOEConfig.CartDetailUrl, 'cartDetailUrl')
      kitCartUrl = trimTrailingSlash(AOEConfig.KitCartUrl, 'kitCartUrl')
      kitCheckoutUrl = trimTrailingSlash(AOEConfig.KitCheckoutUrl, 'kitCheckoutUrl')
      kitRecruiterSelectionUrl = trimTrailingSlash(AOEConfig.KitRecruiterSelectionUrl, 'kitRecruiterSelectionUrl')
      logoutUrl = trimTrailingSlash(AOEConfig.LogoutUrl, 'logoutUrl')
      loginUrl = trimTrailingSlash(AOEConfig.LoginUrl, 'loginUrl')
      checkoutUrl = trimTrailingSlash(AOEConfig.CheckoutUrl, 'checkoutUrl')
      thankyouUrl = trimTrailingSlash(AOEConfig.ThankYouUrl, 'thankyouUrl')
      productReviewUrl = trimTrailingSlash(AOEConfig.ProductReviewUrl, 'productReviewUrl')
      partyOrderEntryUrl = trimTrailingSlash(AOEConfig.PartyOrderEntryUrl, 'partyOrderEntryUrl')
      contactOrderEntryUrl = trimTrailingSlash(AOEConfig.ContactOrderEntryUrl, 'contactOrderEntryUrl')
      invoicePaymentUrl = trimTrailingSlash(AOEConfig.InvoicePaymentUrl, 'invoicePaymentUrl')
      eventManagementUrl = trimTrailingSlash(AOEConfig.EventManagementUrl, 'eventManagementUrl')
      addressBookEditUrl = trimTrailingSlash(AOEConfig.AddressBookEditUrl, 'addressBookEditUrl')
      eventListUrl = trimTrailingSlash(AOEConfig.EventListUrl, 'eventListUrl')
      countryCode = trimTrailingSlash(AOEConfig.CountryCode, 'countryCode')
      hostDashboardUrl = trimTrailingSlash(AOEConfig.HostDashboardUrl, 'hostDashboardUrl')
      currentContentId = Number(AOEConfig.CurrentContentId)
      passwordRegex = trimTrailingSlash(AOEConfig.PasswordRegex, 'passwordRegex')
      orderReceiptUrl = trimTrailingSlash(AOEConfig.OrderReceiptUrl, 'orderReceiptUrl')
      consultantLocatorUrl = trimTrailingSlash(AOEConfig.ConsultantLocatorUrl, 'consultantLocatorUrl')
      webConnectorExtensionsUrl = trimTrailingSlash(AOEConfig.WebConnectorExtensionsApi, 'webConnectorExtensionsUrl')
      leadListUrl = trimTrailingSlash(AOEConfig.LeadListUrl, 'leadListUrl')
      shopUrl = trimTrailingSlash(AOEConfig.ShopUrl, 'shopUrl')
      homeOfficeBeeNumber = AOEConfig.HomeOfficeBeeNumber
      hostBenefitsUrl = trimTrailingSlash(AOEConfig.HostBenefitsUrl, 'hostBenefitsUrl')
      hostPortalUrl = trimTrailingSlash(AOEConfig.HostPortalUrl, 'hostPortalUrl')
      rmaEntryUrl = trimTrailingSlash(AOEConfig.RMAEntryUrl, 'rmaEntryUrl')
      replicatedSiteBusinessName = AOEConfig.ReplicatedSiteBusinessName
      googleMapsAPIKey = trimTrailingSlash(AOEConfig.GoogleMapsAPIKey, 'googleMapsAPIKey')
      siteHomeofficeUrl = trimTrailingSlash(AOEConfig.SiteHomeofficeUrl, 'siteHomeofficeUrl')
      reportUrl = trimTrailingSlash(AOEConfig.ReportUrl ?? '', 'reportUrl')
      termsUrl = trimTrailingSlash(AOEConfig.TermsUrl ?? '', 'termsUrl')
      privacyPolicyUrl = trimTrailingSlash(AOEConfig.PrivacyPolicyUrl ?? '', 'privacyPolicyUrl')
      consultantAgreementUrl = trimTrailingSlash(AOEConfig.ConsultantAgreementUrl ?? '', 'consultantAgreementUrl')
      prohibitedPracticesUrl = trimTrailingSlash(AOEConfig.ProhibitedPracticesUrl ?? '', 'prohibitedPracticesUrl')
      codeOfConductUrl = trimTrailingSlash(AOEConfig.CodeOfConductUrl ?? '', 'codeOfConductUrl')
      backOfficeUrl = trimTrailingSlash(AOEConfig.BackOfficeUrl ?? '', 'backOfficeUrl')
      newUserWizardUrl = trimTrailingSlash(AOEConfig.NewUserWizardUrl ?? '', 'newUserWizardUrl')
      termsAndConditionsPageUrl = trimTrailingSlash(AOEConfig.TermsAndConditionsPageUrl ?? '', 'termsAndConditionsPageUrl')
      becomeConsultantUrl = trimTrailingSlash(AOEConfig.BecomeConsultantUrl ?? '', 'becomeConsultantUrl')
      orderEntryUrl = trimTrailingSlash(AOEConfig.OrderEntryUrl ?? '', 'orderEntryUrl')
      kitEnhancementUrl = trimTrailingSlash(AOEConfig.KitEnhancementUrl ?? '', 'kitEnhancementUrl')
      recipeUrl = trimTrailingSlash(AOEConfig.RecipeUrl ?? '', 'recipeUrl')
      myStoryUrl = trimTrailingSlash(AOEConfig.MyStoryUrl ?? '', 'myStoryUrl')
      defaultConsultantPhotoUrl = AOEConfig.DefaultConsultantPhotoUrl ||
        'https://ttgcommon-180003f.s3.eu-central-1.amazonaws.com/tpc/default-consultant-photo.png'
    }

    const sessionInformationCookie = cookies.get('SessionInformation')

    if (sessionInformationCookie) {
      await LoadSettingFromCookie(sessionInformationCookie)
    } else {
      console.error('SessionInformation cookie is not set')
    }

    logger.debug('aoeConfig', AOEConfig)
  }
  debugLoggingId = cookies.get('X-Debug-Logging-Id') ?? ''
  sessionInformationLoaded = true
}

async function LoadSettingFromCookie(sessionInformationCookie: string) {
  const decodedToken = await getToken(sessionInformationCookie)
  apiKey = decodedToken.ApiKey
  console.log('apiKey:', redactSecret(apiKey))
  bearerToken = decodedToken.AccessToken
  console.log('decodedToken:', decodedToken, 'bearerToken:', redactSecret(bearerToken))
  if (decodedToken.BeeNumberAuthenicatedUser) {
    beeNumberAuthenicatedUser = Number(decodedToken.BeeNumberAuthenicatedUser)
  }
  authenticatedUserClassId =
    typeof decodedToken.ClassId === 'string' ? decodedToken.ClassId : null
  if (decodedToken.CultureName)
  {
  cultureName = decodedToken.CultureName
  }
  else
  {
    cultureName = AOEConfig?.I18nLocale || 'en-US'
  }
  if (decodedToken.BeeNumberSite) {
    beeNumberSite = Number(decodedToken.BeeNumberSite)
  }
  if (decodedToken.WebConnectorToken) {
    webConnectorToken = decodedToken.WebConnectorToken
  }
}

function trimTrailingSlash(url: string | null | undefined, variableName: string): string {
  if (url === null || url === undefined) {
    console.warn(`${variableName} is null or undefined, returning empty string`)
    return ''
  }
  if (url === '/') {
    return url
  }
  return url.replace(/\/$/, '')
}

export async function GetOrderEntryWebUrl(
  ...urlSegments: Array<string>
): Promise<string> {
  let url = import.meta.env.VITE_ORDER_ENTRY_WEB_URL

  if (urlSegments.length > 0) {
    url = url + '/' + urlSegments.join('/')
  }
  return url
}

export async function GetOrderEntryConnectorUrl(
  ...urlSegments: Array<string>
): Promise<string> {
  await LoadSetting()
  let url = orderEntryConnectorUrl
  if (urlSegments.length > 0) {
    url = url + '/json/reply/' + urlSegments.join('/')
  }
  return url
}
export async function GetWebConnectorUrl(
  ...urlSegments: Array<string>
): Promise<string> {
  await LoadSetting()
  let url = webConnectorUrl
  if (urlSegments.length > 0) {
    url = url + '/json/reply/' + urlSegments.join('/')
  }
  return url
}
export async function GetWebConnectorExtensionsUrl(
  ...urlSegments: Array<string>
): Promise<string> {
  await LoadSetting()
  let url = webConnectorExtensionsUrl
  if (urlSegments.length > 0) {
    url = url + '/json/reply/' + urlSegments.join('/')
  }
  return url
}
export async function GetBearerToken(): Promise<string> {
  await LoadSetting()
  return bearerToken
}

export async function GetApiKey(): Promise<string> {
  await LoadSetting()
  return apiKey
}

export async function GetImageRootUrl(): Promise<string> {
  await LoadSetting()
  return imageRootUrl
}

export async function GetReviewRootUrl(): Promise<string> {
  await LoadSetting()
  return reviewRootUrl
}

export async function GetProductRootUrl(): Promise<string> {
  await LoadSetting()
  return productRootUrl
}
export async function GetHostBenefitsUrl(): Promise<string> {
  await LoadSetting()
  return hostBenefitsUrl
}
export async function GetRMAEntryUrl(): Promise<string> {
  await LoadSetting()
  return rmaEntryUrl
}
export async function GetConsultantLocatorUrl(): Promise<string> {
  await LoadSetting()
  return consultantLocatorUrl
}

export async function GetCultureName(): Promise<string> {
  await LoadSetting()
  return cultureName
}

export async function GetWebConnectorToken(): Promise<string> {
  await LoadSetting()
  return webConnectorToken
}

export async function GetBeeNumberAuthenicatedUser(): Promise<number | null> {
  await LoadSetting()
  logger.debug(
    'GetBeeNumberAuthenicatedUser beeNumberAuthenicatedUser:',
    beeNumberAuthenicatedUser,
  )
  return beeNumberAuthenicatedUser
}

export async function GetAuthenticatedUserClassId(): Promise<string | null> {
  await LoadSetting()
  return authenticatedUserClassId
}

export async function GetBeeNumberSite(): Promise<number | null> {
  await LoadSetting()
  logger.debug(
    'GetBeeNumberSite beeNumberSite:',
    beeNumberSite,
  )
  return beeNumberSite
}

export async function GetOrderTypeId(): Promise<string> {
  await LoadSetting()
  return orderTypeId
}

export async function GetKitOrderTypeId(): Promise<string> {
  await LoadSetting()
  return kitOrderTypeId
}

export async function GetWishlistDetailUrl(): Promise<string> {
  await LoadSetting()
  return wishlistDetailUrl
}
export async function GetWishlistUrl(): Promise<string> {
  await LoadSetting()
  return wishlistUrl
}
export async function GetRootUrl(): Promise<string> {
  await LoadSetting()
  return rootUrl
}
export async function GetShopUrl(): Promise<string> {
  await LoadSetting()
  return shopUrl
}

export async function GetCartDetailUrl(): Promise<string> {
  await LoadSetting()
  return cartDetailUrl
}
export async function GetKitCartUrl(): Promise<string> {
  await LoadSetting()
  return kitCartUrl
}
export async function GetKitRecruiterSelectionUrl(): Promise<string> {
  await LoadSetting()
  return kitRecruiterSelectionUrl
}


export async function GetLoginUrl(): Promise<string> {
  await LoadSetting()
  return loginUrl
}
export async function GetLogoutUrl(): Promise<string> {
  await LoadSetting()
  return logoutUrl
}
export async function GetCheckoutUrl(): Promise<string> {
  await LoadSetting()
  return checkoutUrl
}
export async function GetKitCheckoutUrl(): Promise<string> {
  await LoadSetting()
  return kitCheckoutUrl
}
export async function GetThankYouUrl(): Promise<string> {
  await LoadSetting()
  return thankyouUrl
}
export async function GetProductReviewUrl(): Promise<string> {
  await LoadSetting()
  return productReviewUrl
}
export async function GetContactOrderEntryUrl(): Promise<string> {
  await LoadSetting()
  return contactOrderEntryUrl
}
export async function GetPartyOrderEntryUrl(): Promise<string> {
  await LoadSetting()
  return partyOrderEntryUrl
}
export async function GetInvoicePaymentUrl(): Promise<string> {
  await LoadSetting()
  return invoicePaymentUrl
}
export async function GetEventManagementUrl(): Promise<string> {
  await LoadSetting()
  return eventManagementUrl
}
export async function GetAddressBookEditUrl(): Promise<string> {
  await LoadSetting()
  return addressBookEditUrl
}
export async function GetHostPortalUrl(): Promise<string> {
  await LoadSetting()
  return hostPortalUrl
}
export async function GetEventListUrl(): Promise<string> {
  await LoadSetting()
  return eventListUrl
}
export async function GetLeadListUrl(): Promise<string> {
  await LoadSetting()
  return leadListUrl
}
export async function GetCountryCode(): Promise<string> {
  await LoadSetting()
  return countryCode
}


export async function GetReplicatedSiteBusinessName(): Promise<string> {
  await LoadSetting()
  return replicatedSiteBusinessName
}

export async function GetGoogleMapsAPIKey(): Promise<string> {
  await LoadSetting()
  return googleMapsAPIKey
}

export async function GetSiteHomeofficeUrl(): Promise<string> {
  await LoadSetting()
  return siteHomeofficeUrl
}

export async function GetPwsBaseUrl(): Promise<string> {
  await LoadSetting()

  let origin = ''
  if (siteHomeofficeUrl) {
    try {
      origin = new URL(siteHomeofficeUrl).origin
    } catch {
      // Fallback if it's not a valid absolute URL (e.g., relative path)
      const match = siteHomeofficeUrl.match(/^(https?:\/\/[^\/]+)/i)
      if (match) {
        origin = match[1]
      }
    }
  }

  // If we couldn't get an origin from siteHomeofficeUrl, let's use the current window origin if available
  if (!origin && typeof window !== 'undefined') {
    origin = window.location.origin
  }

  // Now let's determine the path prefix from rootUrl (e.g., "/pws/TTGATConsultant/")
  // We want to extract "/pws/"
  let prefix = '/pws/'
  if (rootUrl) {
    const urlPath = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/'
    const match = urlPath.match(/^(\/[^\/]+\/)/)
    if (match) {
      prefix = match[1] // E.g., "/pws/"
    }
  }

  if (origin) {
    // Combine origin and prefix, ensuring correct slashes
    const cleanOrigin = origin.replace(/\/$/, '')
    const cleanPrefix = prefix.replace(/^\//, '').replace(/\/$/, '')
    return `${cleanOrigin}/${cleanPrefix}/`
  }

  // Fallback to the default pattern if we can't build it dynamically
  return `https://www${countryCode.toLowerCase() || 'us'}.tpc.thatchertech.io/pws/`
}

async function getToken(sessionInformationCookie: string) {
  const alg = 'RS256'
  const publicJwkString = import.meta.env.VITE_PUBLIC_JWK
  let publicKey = null

  if (location.protocol === 'http:') {
  } else {
    if (publicJwkString) {
      //
    } else {
      console.error('getToken publicJwkString is null')
    }
    const publicJwk = JSON.parse(publicJwkString)
    try {
      publicKey = await importJWK(publicJwk, alg)
    } catch (err) {
      console.error(err)
    }
  }
  let decodedToken = null

  if (publicKey) {
    try {
      const { payload } = await jwtVerify(sessionInformationCookie, publicKey, {
        audience: 'Nxnw.Adc.Web.Umbraco',
        clockTolerance: 31536000, // 1 year
        requiredClaims: [],
      })

      decodedToken = payload
    } catch (err) {
      console.error(err)
    }
  } else {
    if (location.protocol === 'http:') {
      decodedToken = await decodeJwt(sessionInformationCookie)
    }
  }

  return decodedToken
}

export async function GetHostDashboardUrl(): Promise<string> {
  await LoadSetting()
  return hostDashboardUrl
}

/**
 * Returns the AOE Report URL. If a reportId is supplied, appends `?id={reportId}`
 * (mirrors web2's AOEUrlHelper.GetReportUrl). Returns an empty string if the
 * Umbraco `reportLink` setting isn't configured.
 */
export async function GetReportUrl(reportId?: string): Promise<string> {
  await LoadSetting()
  if (!reportUrl) return ''
  return reportId ? `${reportUrl}?id=${encodeURIComponent(reportId)}` : reportUrl
}

export async function GetCurrentContentId(): Promise<number> {
  await LoadSetting()
  return currentContentId
}

export async function GetHomeOfficeBeeNumber(): Promise<number> {
  await LoadSetting()
  return homeOfficeBeeNumber
}

export async function GetPasswordRegex(): Promise<string> {
  await LoadSetting()

  // HTML decode the regex pattern before returning
  const parser = new DOMParser()
  let decodedPasswordRegex = parser.parseFromString(`<!doctype html><body>${passwordRegex}`, 'text/html').body.textContent || passwordRegex
  // need to do twice because & are encoded as well
  decodedPasswordRegex = parser.parseFromString(`<!doctype html><body>${decodedPasswordRegex}`, 'text/html').body.textContent || passwordRegex
  return decodedPasswordRegex
}

export async function GetOrderReceiptUrl(): Promise<string> {
  await LoadSetting()
  return orderReceiptUrl
}

export async function GetTermsUrl(): Promise<string> {
  await LoadSetting()
  return termsUrl
}

export async function GetPrivacyPolicyUrl(): Promise<string> {
  await LoadSetting()
  return privacyPolicyUrl
}

export async function GetConsultantAgreementUrl(): Promise<string> {
  await LoadSetting()
  return consultantAgreementUrl
}

export async function GetProhibitedPracticesUrl(): Promise<string> {
  await LoadSetting()
  return prohibitedPracticesUrl
}

export async function GetCodeOfConductUrl(): Promise<string> {
  await LoadSetting()
  return codeOfConductUrl
}

export async function GetBackOfficeUrl(): Promise<string> {
  await LoadSetting()
  return backOfficeUrl
}

export async function GetNewUserWizardUrl(): Promise<string> {
  await LoadSetting()
  return newUserWizardUrl
}

export async function GetTermsAndConditionsPageUrl(): Promise<string> {
  await LoadSetting()
  return termsAndConditionsPageUrl
}

export async function GetBecomeConsultantUrl(): Promise<string> {
  await LoadSetting()
  return becomeConsultantUrl
}

export async function GetOrderEntryUrl(): Promise<string> {
  await LoadSetting()
  return orderEntryUrl
}

export async function GetKitEnhancementUrl(): Promise<string> {
  await LoadSetting()
  return kitEnhancementUrl
}

export async function GetRecipeUrl(): Promise<string> {
  await LoadSetting()
  return recipeUrl
}

export async function GetMyStoryUrl(): Promise<string> {
  await LoadSetting()
  return myStoryUrl
}

export async function GetDebugLoggingId(): Promise<string> {
  await LoadSetting()
  return debugLoggingId
}

export async function GetDefaultConsultantPhotoUrl(): Promise<string> {
  await LoadSetting()
  return defaultConsultantPhotoUrl
}
